import styled from 'styled-components';
import { colors, radius } from '../../styles/tokens';

export const ContainerInput = styled.div`
  position: relative;

  width: 100%;
  aspect-ratio: 16 / 9;

  border-radius: ${radius.lg};
  overflow: hidden;

  background-color: ${colors.surfaceContainerLow};
  border: 1px solid ${colors.outlineVariant}1a;
`;

export const ContainerMidia = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.85;
    transition: transform 0.7s;
  }

  ${ContainerInput}:hover & img {
    transform: scale(1.05);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;

  background: linear-gradient(to top, ${colors.surface}cc 0%, transparent 40%);

  pointer-events: none;
`;

export const PlayButton = styled.button`
  position: absolute;
  bottom: 24px;
  left: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 56px;
  height: 56px;
  flex-shrink: 0;

  background: rgba(73, 33, 0, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid ${colors.primary}33;
  border-radius: ${radius.full};
  cursor: pointer;

  color: ${colors.primary};

  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`;

export const PlayInfo = styled.div`
  position: absolute;
  bottom: 32px;
  left: 92px;

  p {
    font-size: 11px;
    line-height: 1.4;
  }

  p:first-child {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: ${colors.primary};
  }

  p:last-child {
    color: ${colors.onSurface};
    opacity: 0.8;
  }
`;

export const ActionsWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  display: flex;
  gap: 8px;
`;

export const ReplaceLabel = styled.span<{ locked?: boolean }>`
  cursor: ${({ locked }) => (locked ? 'not-allowed' : 'pointer')};

  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 16px;

  background: ${({ locked }) =>
    locked
      ? colors.surfaceContainerHighest
      : `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryContainer} 100%)`};
  border-radius: ${radius.DEFAULT};
  box-shadow: ${({ locked }) => (locked ? 'none' : `0 8px 20px ${colors.surface}80`)};

  transition: filter 0.2s;

  &:hover {
    filter: ${({ locked }) => (locked ? 'none' : 'brightness(1.1)')};
  }

  span {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: ${({ locked }) =>
      locked ? colors.onSurfaceVariant : colors.onPrimary};
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  background: ${colors.surface}b3;
  border: 1px solid ${colors.outlineVariant}4d;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  color: ${colors.onSurfaceVariant};

  &:hover {
    color: ${colors.error};
  }
`;

export const Input = styled.input`
  display: none;
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;
